import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useParameterReducer = () =>
  useSelector((state: ApplicationState) => state.parameter);
